/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_NotificationsInputs */

const es_tools_legajox_notifications = /** @type {(inputs: Tools_Legajox_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando notificaciones en Legajox...`)
};

const en_tools_legajox_notifications = /** @type {(inputs: Tools_Legajox_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Querying Legajox notifications...`)
};

/**
* | output |
* | --- |
* | "Querying Legajox notifications..." |
*
* @param {Tools_Legajox_NotificationsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_notifications = /** @type {((inputs?: Tools_Legajox_NotificationsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_NotificationsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_notifications(inputs)
	return en_tools_legajox_notifications(inputs)
});
export { tools_legajox_notifications as "tools.legajox.notifications" }